window.ValetStep2 = {

    init() {

        this.input = document.querySelector(
            "[data-valet-quantity]"
        );

        if (!this.input) return;

        const booking = window.valetBooking;

        const minimum =
            booking.minimumQuantity || 1;

        const current =
            booking.crates || 0;

        this.input.min = minimum;

        this.input.value =
            Math.max(current, minimum);

        // Keep booking in sync
        booking.crates =
            Number(this.input.value);

            if (window.exxtraBookingSummary) {

                window.exxtraBookingSummary.updatePricing();

            }

        this.bind();

    },

    bind() {

        this.input.removeEventListener(
            "input",
            this.handleInput
        );

        this.input.addEventListener(
            "input",
            this.handleInput
        );

    },

    handleInput(event) {

        const booking = window.valetBooking;

        const minimum =
            booking.minimumQuantity || 1;

        let quantity =
            parseInt(event.target.value, 10);

        if (
            isNaN(quantity) ||
            quantity < minimum
        ) {

            quantity = minimum;

        }

        event.target.value = quantity;

        booking.crates = quantity;

        if (window.exxtraBookingSummary) {

            window.exxtraBookingSummary.updatePricing();

        }

    }

};